<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!itemsListStatuses">
    <tt-list [ttData]="itemsListStatuses"></tt-list>

    <tt-card>
        <tt-button-goto [ttText]="'orderlinestatus_rfidconnect'" [ttGoto]="'rfidconnect'" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: orderInternalNo }"></tt-button-goto>
    </tt-card>
</tt-page>
